const headers = {
  name: "Customers",
  navigate: {
    path: [
      {
        name: "Customers",
        path: "/app/customers",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
